import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../../../Outsourced";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";


/**
 * Created by jonas on 2022-01-12.
 */

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    constructor() {
    }



    shouldRun():boolean {
        return Outsourced.model.gameData.brokeTheBank && !Outsourced.model.isGodModeDeluxe;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        const maxWinSymbols = Outsourced.reelView.getAllSymbols().filter((sym) => sym.symbolName == "MAX");

        tl.add(() => {
            Outsourced.keypadPlugin.setZeroBetSpinCounter(-1);
            Outsourced.soundPlayer.fadeOutMusic();
            Outsourced.keypadPlugin.setWin(Outsourced.model.gameData.accumulatedRoundWin,
                                               Outsourced.model.data.mode != GameMode.NORMAL,
                                               Outsourced.isWinBelowStake()); // what
        })

        if (maxWinSymbols.length == 4) {
            tl.add(maxWinSymbols.map((sym) => sym.getWinBlink()));
            tl.add(maxWinSymbols.map((sym) => sym.getWinAnimation()));
            tl.add(() => {}, '>0.3');
        }

        tl.add(Outsourced.soundPlayer.playSoundBased("maxWinIntro"));
        tl.add(Outsourced.transitionScreen.showMaxWin());
        tl.add(() => {
            Outsourced.soundPlayer.playLoopingSound("winCapLoop");
        }, '<1.3')

        //if (SlotGame.apiPlugin.gameClientConfiguration.gambleFiftyFiftyAllowed) {
        //    tl.add(() => controller.finish(), '>2');
        //} else {
            tl.add(Outsourced.transitionScreen.enableButton(() => this.onButtonClick(controller)), '>2.5');
        //}
     }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            Outsourced.soundPlayer.switchMusic(GameMode.NORMAL)
            Outsourced.keypadPlugin.setWin(Outsourced.model.data.accumulatedRoundWin,
                                           Outsourced.model.data.mode != GameMode.NORMAL,
                                           Outsourced.isWinBelowStake());
            Outsourced.reelView.enable();
            Outsourced.reelView.setToNormal();
        })
        tl.add(Outsourced.backgroundElements.setToBaseGame());
        tl.add(Outsourced.transitionScreen.hideMaxWin());

        tl.add(() => {
            Outsourced.soundPlayer.fadeInMusic();
            Outsourced.soundPlayer.stopSound("winCapLoop");
        })
        tl.add(() => controller.finish());

    }
}